import { Component, Input, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { environment } from '../../../environments/environment';
import { LocalizationService } from '../../services/localization/localization.service';
import { FunctionsService } from '../../services/functions/functions.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TestResultService } from '../../services/test-result/test-result.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-hero-results',
  templateUrl: './hero-results.component.html',
  styleUrls: ['./hero-results.component.scss']
})
export class HeroResultsComponent implements OnInit {
  @Input() public content: Entry<any>;

  public oilBarrels: number;
  public plantedTrees: number;
  public protectedTrees: number;
  public sharingNotification = '';
  public linkToShare$: Observable<string>;
  public testResult: any;

  constructor(
    private localizationService: LocalizationService,
    private fnService: FunctionsService,
    private testResultService: TestResultService
  ) {
    this.linkToShare$ = this.getShareUrl();
  }

  ngOnInit() {
    const testResult$ = this.testResultService.getTestResult();
    testResult$.subscribe(testResult => {
      if (testResult) {
        this.oilBarrels = Math.round(testResult.co2e / 1000 / 0.433);
        if (!this.testResult || _.isEqual(this.testResult, testResult.co2e)) {
          // Update only if changed...
          this.testResult = testResult;
        }
      }
    });

    this.linkToShare$ = this.getShareUrl();
  }

  private getShareUrl() {
    if (this.testResult) {
      return this.fnService.hashId().pipe(map(id => this.host));
    }
  }

  get host() {
    if (this.localizationService.locale.getValue() !== 'en-US') {
      return (
        environment.host + '/' + this.localizationService.locale.getValue()
      );
    } else {
      return environment.host;
    }
  }

  get source() {
    return environment.host.replace('https://', '').replace('http://', '');
  }

  get title() {
    return this.mailSubject;
  }

  get mailSubject() {
    const shareToMailSubject = this.content.fields.shareToMailSubject;
    return shareToMailSubject.replace('{{oilBarrels}}', this.oilBarrels);
  }

  get oilHeading() {
    const oilHeading = this.content.fields.oilInfographicsHeading;
    return oilHeading.replace('{{oilBarrels}}', this.oilBarrels);
  }

  get treesHeading() {
    let treesHeading = this.content.fields.treesInfographicsHeading;
    treesHeading = treesHeading.replace('{{plantedTrees}}', this.plantedTrees);
    return treesHeading.replace('{{protectedTrees}}', this.protectedTrees);
  }
}
